import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddStaffComponent } from './add-staff.component';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '../../../shared/material.module';
import { AddStaffMarketingModule } from './components/add-staff-marketing/add-staff-marketing.module';
import { StateManagementButtonsModule } from '../../../shared/componets/state-management-buttons/state-management-buttons.module';
import { AddStaffInfoModule } from './components/add-staff-info/add-staff-info.module';
import { AddStaffWrapperModule } from './components/add-staff-wrapper/add-staff-wrapper.module';
import { ManualAddModule } from './components/manual-add/manual-add.module';
import { UploadStaffModule } from './components/upload-staff/upload-staff.module';
import { OnBoardingVideoModule } from '../shared/on-boarding-video/on-boarding-video.module';
import { ScheduleCreationStateButtonsModule } from '../shared/schedule-creation-state-buttons/schedule-creation-state-buttons.module';



@NgModule({
  declarations: [
    AddStaffComponent,
  ],
  exports: [AddStaffComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    AddStaffMarketingModule,
    StateManagementButtonsModule,
    AddStaffInfoModule,
    AddStaffWrapperModule,
    ManualAddModule,
    UploadStaffModule,
    OnBoardingVideoModule,
    ScheduleCreationStateButtonsModule
  ]
})
export class AddStaffModule { }
